module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/baylor-university-839f1ef3fdb98194b314fa073758c9c9.jpg";